import { del, get, post, put } from "./aws_api_helper";
import * as url from "./url_helper";
import axios from "axios";

import accessToken from "../helpers/jwt-token-access/accessToken";
import jwt_decode from "jwt-decode";

const AWS_API_URL = process.env.REACT_APP_AWS_API_URL;

// Add Sub organization
const addOrganization = (organization) => post(url.ORGANIZATION, organization);

// Add Customer
const addCustomer = (customer) => post(url.POST_CUSTOMER, customer);

// Delete Customer
const deleteCustomer = (orgCode) => del(`${url.POST_CUSTOMER}?orgcode=${orgCode}`);

// Get Customer Org Accounts
const getCustomerOrgAccounts = () => get(url.GET_CUSTOMER_ORG_ACCOUNTS);

// Get pricing information from AWS
//Updated to include accountNumber
const getPricingInfo = (accountNumber, subscription, orgCode) => {
  console.log("----== getPricingInfo ", url.GET_LICENSE_PRICE_INFO);
  //Updated to include accountNumber
  return get(
    `${url.GET_LICENSE_PRICE_INFO}?accountnumber=${accountNumber}&subscription=${subscription}&orgcode=${orgCode}`
  );
};

const getAssetInsightMetric = (accCodes, orgCode) => {
  // console.log("----== getAssetInsightMetric ", url.GET_METRIC_INFO);
  const accCode = encodeURI(accCodes);
  return get(
    `${url.GET_METRIC_INFO}/assetinsight?accCode=${accCode}&orgCode=${orgCode}`
  );
};

const getComplianceMetric = (accCodes, orgCode) => {
  // console.log("----== getComplianceMetric ", url.GET_METRIC_INFO);
  const accCode = encodeURI(accCodes);
  return get(
    `${url.GET_METRIC_INFO}/compliance?accCode=${accCode}&orgCode=${orgCode}`
  );
};

const getCostInsightMetric = (accCodes, orgCode) => {
  // console.log("----== getCostInsightMetric ", url.GET_METRIC_INFO);
  const accCode = encodeURI(accCodes);
  return get(
    `${url.GET_METRIC_INFO}/costinsight?accCode=${accCode}&orgCode=${orgCode}`
  );
};

const getSecurityPostureMetric = (accCodes, orgCode) => {
  // console.log("----== getSecurityPostureMetric ", url.GET_METRIC_INFO);
  const accCode = encodeURI(accCodes);
  return get(
    // `${url.GET_METRIC_INFO}/security?accCode=${accCode}&orgCode=${orgCode}`
    `${url.GET_METRIC_INFO}/securityMetric?accCode=${accCode}&orgCode=${orgCode}`
  );
};

const getEventInsightMetric = (orgCode) => {
  return get(
    `${url.GET_METRIC_INFO}/eventinsight?orgCode=${orgCode}`
  );
};

const getWafrMetric = () => {
  return get(
    `${url.GET_METRIC_INFO}/wafr`
  );
};

// Login
// const postLogin = (data) => post(url.POST_LAMBDA_LOGIN, data)
const postLogin = (data) => post(url.POST_LAMBDA_LOGINWITHMFA, data);

// Verify TOTP
const postVerifyTotp = (data) => post(url.POST_LAMBDA_LOGINVERIFYTOTP, data);

// Forget Password
const postForgetPwd = (data) => put(url.POST_LAMBDA_FORGET_PASSWORD, data);

// Change Password
const resetPwd = (data) => put(url.PUT_RESET_PASSWORD, data);

const resetPasswordFrgt = (dto) => {
  return put(url.POST_LAMBDA_RESET_FORGOT_PASSWORD, dto);
};

//Orgs name
const getOrgsName = (data) => {
  console.log("----== getOrgsName ", url.GET_LAMBDA_ORGS_NAME);
  return get(`${url.GET_LAMBDA_ORGS_NAME}`);
};
// Get list of orgs and accounts
const getOrgsAndAccts = (data) => {
  console.log(
    "----== getOrgsAndAccts ",
    url.GET_LAMBDA_LIST_OF_ORGS_AND_ACCOUNTS
  );
  return get(`${url.GET_LAMBDA_LIST_OF_ORGS_AND_ACCOUNTS}`, data);
};
// Get main dashboard data
const getLicensing = () => {
  return get(`${url.GET_LAMBDA_LICENSING}`);
};
const addNewUserPost = (payload) => {
  return post(url.POST_LAMBDA_NEW_USER, payload);
};
const getProfileRoleInfo = () => {
  return get(`${url.GET_LAMBDA_PROFILE_ROLE_INFO}`);
};
const postRegister = (data) => post(url.POST_LAMBDA_REGISTER, data);
const putRegister = (data) => put(url.PUT_LAMBDA_REGISTER, data);
const getAccRules = () => {
  return get(url.GET_LAMBDA_ACC_RULES);
};
const getAllRules = () => {
  return get(url.GET_LAMBDA_ALL_RULES);
};
const getAwsAccountNumber = () => {
  return get(url.GET_LAMBDA_AWS_ACCOUNT_NUMBER);
};

const postAwsAccountNumber = (data) => {
  return post(url.POST_LAMBDA_AWS_ACCOUNT_NUMBER, data);
};

// HP Actual API Call
const postOrgAccount = (data) => post(url.POST_LAMBDA_ORG_ACCOUNT, data);

const editUserPatch = (payload) => {
  return put(url.PUT_LAMBDA_EDIT_USER, payload);
};

const toggleUserService = (payload) => {
  console.log("--== ** toggleUserService ", payload);
  const { email, action } = payload;
  const queryParams = `?email=${encodeURIComponent(email)}&action=${encodeURIComponent(action)}`;
  return put(`${url.PUT_LAMBDA_EDIT_USER}${queryParams}`, {});
};

const deleteUserService = (payload) => {
  console.log("--== ** deleteUserService ", payload);
  return put(url.DELETE_LAMBDA_USER, payload);
};
const updateRules = (payload) => {
  return put(url.PUT_LAMBDA_RULES_MAP, payload);
};
const putToggleRulezLambda = (params) => {
  return put(url.PUT_LAMBDA_RULES_MAP, { payload: params });
};
// Update AWS Account
const updateAccount = (data) => put(url.UPDATE_LAMBDA_ORG_ACCOUNT, data);

const getActivateEmail = (data) => post(url.GET_ACCOUNT_ACTIVATION, data);

const reActiveGet = (payload) => {
  console.log("--== ** ReActiveGet ", payload);
  return get(`${url.GET_REACTIVE_USER_LAMBDA}?email=${payload.email}`);
};

const getAccountsAndTabToken = () => {
  console.log("does one exist");
  return get(url.GET_TAB_TOKEN_TABLEAU_LAMBDA);
};

const getTabToken = () => {
  console.log("getTabToken API call");
  return get(url.GET_TAB_TOKEN_TABLEAU_LAMBDA);
};

const validateProspectiveToken = (payload) => {
  console.log("sending validate, " + payload.token);
  return post(url.PUT_VALIDATE_PROSPECTIVE_TOKEN, payload);
};

const addResourceGroup = (data) => {
  console.log("----== addResourceGroup ", url.POST_LAMBDA_RESOURCE_GROUP);
  return post(url.POST_LAMBDA_RESOURCE_GROUP, data);
};

const editResourceGroup = (data) => {
  console.log("----== editResourceGroup ", url.POST_LAMBDA_RESOURCE_GROUP);
  return put(url.POST_LAMBDA_RESOURCE_GROUP, data);
};

const deleteResourceGroup = (resourceGroupName, orgCode) => {
  console.log("----== deleteResourceGroup ", url.POST_LAMBDA_RESOURCE_GROUP);
  const queryParams = `?resourceGroupName=${encodeURIComponent(
    resourceGroupName
  )}&orgCode=${encodeURIComponent(String(orgCode))}`;
  console.log("Query Parameters:", queryParams);
  return del(`${url.POST_LAMBDA_RESOURCE_GROUP}${queryParams}`);
};

const getResourceGroups = () => {
  console.log("----== getResourceGroups ", url.GET_LAMBDA_RESOURCE_GROUPS);
  return get(`${url.GET_LAMBDA_RESOURCE_GROUPS}`);
};

const getRuleRemediation = (resourceName) => {
  console.log(
    "----== getResourceGroups ",
    url.GET_RULE_REMEDIATION,
    " requested resource: ",
    resourceName
  );
  // TODO: add resource name
  return get(`${url.GET_RULE_REMEDIATION}?ruleId=${resourceName}`);
};

const getIaacMetrics = (orgcode) =>
  get(`${url.GET_IAAC_METRICS}?orgCode=${orgcode}`);

const getUploadFileUrl = (fileName, orgcode, username, uuid) => {
  const encodedUsername = username.replace(/\+/g, "%2B");
  const lastDotIndex = fileName.lastIndexOf(".");
  let fullFileName;
  if (lastDotIndex === -1) {
    fullFileName = `${fileName}%26${orgcode}%26${encodedUsername}%26${uuid}`;
  } else {
    const fileNameWithoutExtension = fileName.slice(0, lastDotIndex);
    const fileExtension = fileName.slice(lastDotIndex + 1);
    fullFileName = `${fileNameWithoutExtension}%26${orgcode}%26${encodedUsername}%26${uuid}.${fileExtension}`;
  }

  const apiUrl = `${url.GET_FILE_UPLOAD_URL}?fileName=${fullFileName}`;

  console.log("getUploadFileUrl = ", apiUrl);
  return get(apiUrl);
};

const postUploadFile = (fileData, uploadUrl) => {
  // console.log(`fileData=${fileData} uploadUrl=${uploadUrl}`);

  let contentType = "application/octet-stream"; // Default to a general binary type

  if (fileData.type) {
    contentType = fileData.type;
  }
  // console.log("contentType: ", contentType);

  return axios.put(uploadUrl, fileData, {
    headers: {
      "Content-Type": contentType,
    },
  });
};

const postFileCommitDetails = (
  orgcode,
  filename,
  username,
  author,
  projectName,
  branch,
  version,
  comment,
  uuid
) => {
  console.log(
    `orgcode=${orgcode}, filename=${filename}, username=${username}, author=${author}, projectName=${projectName}, branch=${branch}, version=${version}, comment=${comment} `
  );
  const lastDotIndex = filename.lastIndexOf(".");
  let fullFileName;
  if (lastDotIndex === -1) {
    fullFileName = `${filename}&${orgcode}&${username}&${uuid}`;
  } else {
    const fileNameWithoutExtension = filename.slice(0, lastDotIndex);
    const fileExtension = filename.slice(lastDotIndex + 1);
    fullFileName = `${fileNameWithoutExtension}&${orgcode}&${username}&${uuid}.${fileExtension}`;
  }

  const templateBucketUri = `${orgcode}/${fullFileName}`;
  const commitObject = {
    orgCode: orgcode,
    fileName: filename,
    userName: username,
    author: author,
    projectName: projectName,
    branch: branch,
    version: version,
    comments: comment,
    templateBucketUri,
  };
  return post(url.POST_FILE_COMMIT_DETAILS, commitObject);
};

const getIaacFileHistory = (orgcode) =>
  get(`${url.GET_IAAC_FILE_HISTORY}?orgCode=${orgcode}`);

const getDownloadFile = (fileId, fileType) => {
  console.log(`fileId=${fileId}`);
  const apiUrl = `${url.GET_IAAC_FILE}?fileName=${encodeURIComponent(
    fileId
  )}&key=${fileType}`;
  console.log(`Download file apiUrl=${apiUrl}`);
  return get(apiUrl);
};

const getIaacSubscription = (orgcode) =>
  get(`${url.GET_IAAC_SUBSCRIPTION}?orgCode=${orgcode}`);

const postIaacSubscription = (orgcode, subscription) =>
  post(`${url.POST_IAAC_SUBSCRIPTION}?orgCode=${orgcode}`, subscription);

const putIaacSubscription = (orgcode, subscription) =>
  put(`${url.PUT_IAAC_SUBSCRIPTION}?orgCode=${orgcode}`, subscription);

const getIaacLicense = (orgcode) =>
  get(`${url.GET_IAAC_LICENSE}?orgCode=${orgcode}`);

const getReleaseNotes = (key) => get(`${url.GET_RELEASE_NOTES}?key=${key}`);

const getReleaseDetails = (fileName) =>
  get(`${url.GET_RELEASE_DETAILS}?fileName=${fileName}`);

const postSupportEmail = (data) =>
  post(url.POST_SUPPORT_EMAIL, data.emailPayload);

// AWS Marketplace
const addFulfillment = (payload) => {
  console.log("----== addFulfillment ", url.POST_AWS_FULFILLMENT, payload);
  return post(`${url.POST_AWS_FULFILLMENT}?token=${payload.token}`, {
    email: payload.email,
  });
};

const awsOnboard = (payload) => {
  console.log("----== awsOnboard ", url.POST_AWS_ONBOARD, payload);
  return post(`${url.POST_AWS_ONBOARD}?token=${payload.token}`, payload);
};

const postFeatureConfiguration = (payload) => {
  console.log(
    "----== postFeatureConfiguration ",
    url.POST_FEATURE_CONFIGURATION,
    payload
  );
  return post(url.POST_FEATURE_CONFIGURATION, payload);
};

const postAccountConfiguration = (payload) => {
  console.log(
    "----== postAccountConfiguration ",
    url.POST_ACCOUNT_CONFIGURATION,
    payload
  );
  return put(url.POST_ACCOUNT_CONFIGURATION, payload);
};

const fetchFunctionCount = async (
  functionName,
  accountNumber,
  roleName,
  externalId,
  signal
) => {
  const token = accessToken();
  let username;
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const authUser = jwt_decode(obj.token);
    username = authUser.sub.charAt(0) + authUser.sub.slice(1);
  }

  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "spring.cloud.function.definition": functionName,
      authorization: `Bearer ${token}`,
      username: username,
    },
    body: JSON.stringify({ accountNumber, readOnlyRole: roleName, externalId }),
    signal: signal,
  };

  return await fetch(AWS_API_URL + "/scan", options);
};

const verifyAccountStatus = async (accountNumber, roleName, externalId) => {
  const token = accessToken();
  let username;
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const authUser = jwt_decode(obj.token);
    username = authUser.sub.charAt(0) + authUser.sub.slice(1);
  }

  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "spring.cloud.function.definition": "VerifyAccountStatus",
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      username: username,
    },
    body: JSON.stringify({ accountNumber, readOnlyRole: roleName, externalId }),
  };

  try {
    const response = await fetch(AWS_API_URL + "/scan", options);
    const responseText = await response.text(); // Read response as plain text

    return {
      status: response.status, // Include HTTP status
      body: responseText, // Include backend response
    };
  } catch (error) {
    console.error("Error verifying account status:", error);
    return {
      status: 500, // Assign a generic error code for exceptions
      body: error.message, // Return the exception message
    };
  }
};

const verifyBucketPolicyStatus = async (
  role,
  accountNumber,
  bucketName,
  readOnlyRole,
  selectedRegion,
  key,
  externalId
) => {
  const token = accessToken();
  let username;
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const authUser = jwt_decode(obj.token);
    username = authUser.sub.charAt(0) + authUser.sub.slice(1);
  }

  const options = {
    method: "POST",
    url: AWS_API_URL + "/cloudnova/bucketpolicy",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      username: username,
    },
    body: JSON.stringify({
      role,
      accountNumber,
      bucketName,
      readOnlyRole,
      selectedRegion,
      externalId,
    }),
  };

  try {
    const response = await fetch(
      `${AWS_API_URL}/cloudnova/bucketpolicy?key=${key}`,
      options
    );
    if (response.ok) {
      const data = await response.text();
      return data;
    } else {
      const data = await response.text();
      throw new Error("Server returned " + data);
    }
  } catch (error) {
    console.log("In verifyBucketPolicyStatus, error: ", error.message);
    return error.message;
  }
};

const fetchKibanaDashboardsApi = (orgcode) =>
  get(`${url.FETCH_KIBANA_DASHBOARDS_URL}?orgCode=${orgcode}`);

const fetchBillingRecordsApi = () => {
  console.log("Billing Api called");
  return get(`${url.FETCH_BILLING_RECORDS_URL}`);
};

// Tag Allocation Cost insight
// Download tags
const fetchTagsApi = (orgCode, accountNumber, username) => {
  console.log("Download Tags Api called");
  return get(`${url.COST_INSIGHT_TAG_ALLOCATION}/download`, {
    params: {
      orgCode: orgCode,
      accountNumber: accountNumber,
      // username: username
    },
  });
};

const fetchTagAllocationAccountsApi = () => {
  console.log("Fetch Tag Allocation Accounts Api called");
  return get(`${url.COST_INSIGHT_GET_TAG_ALLOCATION_ACCOUNTS}`);
};

const fetchTagDetailsApi = (orgCode, accountNumber) => {
  console.log("Get Tag Details API called with:", { orgCode, accountNumber });
  return get(`${url.COST_INSIGHT_TAG_ALLOCATION}/getTagDetails`, {
    params: {
      orgCode: orgCode,
      accountNumber: accountNumber,
    },
  });
};

// const uploadTagsApi = (orgCode, accountNumber, fileContent) => {
//   console.log("#############Upload Tags Api called with orgCode=",orgCode, "accountNumber=",accountNumber, "fileContent=",fileContent);
//   return post(`${url.COST_INSIGHT_TAG_ALLOCATION}/upload?orgCode=${orgCode}&accountNumber=${accountNumber}`, fileContent);
// }
const uploadTagsApi = (orgCode, accountNumber, fileName, formData) => {
  console.log(
    "#############Upload Tags Api called with orgCode=",
    orgCode,
    "accountNumber=",
    accountNumber,
    "formData=",
    formData
  );

  for (let pair of formData.entries()) {
    console.log("uploadTagsApi, pair:", pair[0] + ": " + pair[1]);
  }

  return post(
    `${url.COST_INSIGHT_TAG_ALLOCATION}/upload?orgCode=${orgCode}&accountNumber=${accountNumber}&filename=${fileName}`,
    formData
    // {
    //   headers: {
    //     "Content-Type": "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
    //   },
    // }
  );
};

const getOrganizationScope = () => {
  return get(`${url.GET_ORGANIZATION_SCOPE}`);
};

const getWafrQuestionnaire = (getWafrQuestionnairePayload) => {
  const { orgCode, accCode, workloadId } = getWafrQuestionnairePayload;
  return get(
    `${url.GET_WAFR_QUESTIONNAIRE}?orgCode=${orgCode}&accountCode=${accCode}&workloadId=${workloadId}`
  );
};

const getWafrAssessmentList = () => {
  return get(`${url.GET_WAFR_ASSESSMENT_LIST}`);
};

const deleteWafrAssessment = (deleteWafrAssessmentPayload) => {
  console.log(
    "🚀 ~ deleteWafrAssessment ~ deleteWafrAssessmentPayload:",
    deleteWafrAssessmentPayload
  );
  const { workloadId } = deleteWafrAssessmentPayload;
  console.log("🚀 ~ deleteWafrAssessment ~ workloadId:", workloadId);
  return del(`${url.DELETE_WAFR_QUESTIONNAIRE}?workloadId=${workloadId}`);
};

const getWafrSummary = (getWafrSummaryPayload) => {
  const { accNumber, workloadId } = getWafrSummaryPayload;
  return get(
    `${url.GET_WAFR_SUMMARY}?accountNumber=${accNumber}&workloadId=${workloadId}`
  );
};

const getCisPosture = (getCisPosturePayload) => {
  console.log(
    "🚀 ~ getCisPosture ~ getCisPosturePayload:",
    getCisPosturePayload
  );
  const { orgCode } = getCisPosturePayload;
  return get(`${url.GET_CIS_POSTURE}?orgCode=${orgCode}`);
};

const postCisPosture = (postCisPosturePayload) => {
  console.log(
    "🚀 ~ postCisPosture ~ postCisPosturePayload:",
    postCisPosturePayload
  );
  return post(url.GET_CIS_POSTURE, postCisPosturePayload);
};

const updateWafrAnswer = (updateWafrAnswerPayload) => {
  return put(`${url.UPDATE_WAFR_QUESTIONNAIRE}`, updateWafrAnswerPayload);
};

const postWafrAssessment = (payload) => {
  console.log("----== postWafrAssessment ", url.POST_WAFR_ASSESSMENT, payload);
  return post(url.POST_WAFR_ASSESSMENT, payload);
};

const postWafrAssessmentPreValidate = (payload) => {
  console.log("----== postWafrAssessmentPreValidate ", url.POST_WAFR_ASSESSMENT_PRE_VALIDATE, payload);
  return post(url.POST_WAFR_ASSESSMENT_PRE_VALIDATE, payload);
};

const postCisScan = (payload) => {
  console.log("----== postCisScan ", url.POST_CIS_SCAN, payload);
  return post(url.POST_CIS_SCAN, payload);
};

const postAutomatedChecks = (payload) => {
  console.log("----== postCisScan ", url.POST_CIS_SCAN, payload);
  return post(url.POST_AUTOMATED_CHECKS, payload);
};

const getFlaggedDetails = (getFlaggedDetailsPayload) => {
  const { accountNumber, choiceId, workloadId } = getFlaggedDetailsPayload;
  return get(
    `${url.GET_FLAGGED_DETAILS}?accountNumber=${accountNumber}&workloadId=${workloadId}&choiceId=${choiceId}`
  );
};

const postCompleteAssessment = (payload) => {
  console.log(
    "----== postCompleteAssessment ",
    url.POST_COMPLETE_ASSESSMENT,
    payload
  );
  return post(url.POST_COMPLETE_ASSESSMENT, payload);
};

const getWafrReport = (getWafrReportPayload) => {
  const { accNumber, workloadId } = getWafrReportPayload;
  return get(
    `${url.GET_WAFR_REPORT}?accountNumber=${accNumber}&workloadId=${workloadId}`
  );
};

const getWafrPdfReport = (getWafrPdfReportPayload) => {
  // Extract format from payload or default to 'pdf'
  const { format = 'pdf', ...payload } = getWafrPdfReportPayload;
  // Use POST request with the full payload in the body and format as query param
  return post(`${url.GET_WAFR_PDF_REPORT}?reportFormat=${format}`, payload);
};

const getMilestonePdfReport = (getMilestonePdfReportPayload) => {
  // Extract format from payload or default to 'pdf'
  const { format = 'pdf', ...payload } = getMilestonePdfReportPayload;
  // Use POST request with the full payload in the body and format as query param
  return post(`${url.GET_MILESTONE_PDF_REPORT}?reportFormat=${format}`, payload);
};

const getMilestoneList = (getMilestoneListPayload) => {
  const { workloadId } = getMilestoneListPayload;
  return get(`${url.GET_MILESTONE_LIST}?workloadId=${workloadId}`);
};

const getMilestoneDetails = (getMilestoneDetailsPayload) => {
  const { accCode, workloadId, milestoneName } = getMilestoneDetailsPayload;
  return get(
    `${url.GET_MILESTONE_DETAILS}?accountCode=${accCode}&workloadId=${workloadId}&milestoneName=${milestoneName}`
  );
};

const postCreateMileStone = (payload) => {
  console.log(
    "----== postCreateMileStone ",
    url.POST_MILESTONE_DETAILS,
    payload
  );
  return post(url.POST_MILESTONE_DETAILS, payload);
};

const getWafrAttachmentsUrl = (getWafrAttachmentsUrlPayload) => {
  const { accountCode, workloadId, fileName, questionId } =
    getWafrAttachmentsUrlPayload;
  return get(
    `${url.WAFR_ATTACHMENTS}?accountCode=${accountCode}&workloadId=${workloadId}&questionId=${questionId}&fileName=${fileName}&requestedService=getAttachmentsUrl`
  );
};

const listWafrAttachments = (listWafrAttachmentsPayload) => {
  const { accountCode, workloadId, questionId } = listWafrAttachmentsPayload;
  return get(
    `${url.WAFR_ATTACHMENTS}?accountCode=${accountCode}&workloadId=${workloadId}&questionId=${questionId}&requestedService=listAttachments`
  );
};

const downloadWafrAttachments = (downloadWafrAttachmentsPayload) => {
  const { accountCode, workloadId, fileName, questionId } =
    downloadWafrAttachmentsPayload;
  return get(
    `${url.WAFR_ATTACHMENTS}?accountCode=${accountCode}&workloadId=${workloadId}&questionId=${questionId}&fileName=${fileName}&requestedService=getDownloadAttachmentsUrl`
  );
};

const getWafrStakeholders = (getWafrStakeholdersPayload) => {
  const { accountCode, workloadId, questionId } = getWafrStakeholdersPayload;
  return get(
    `${url.WAFR_STAKEHOLDER}?accountCode=${accountCode}&workloadId=${workloadId}&questionId=${questionId}&requestedService=listAttachments`
  );
};

const getOrganizationalUnits = (awsAccountId) => {
  return get(`${url.MULTI_ACCOUNT_ORG}?awsAccountId=${awsAccountId}`);
};

const generateYaml = (payload) => {
  console.log("----== generateYaml ", url.MULTI_ACCOUNT_YAML, payload);
  return post(url.MULTI_ACCOUNT_YAML, payload);
};

const generateEventInsightYaml = (payload) => {
  console.log("----== generateEventInsightYaml ", url.MULTI_ACCOUNT_EVENT_INSIGHT_YAML, payload);
  return post(url.MULTI_ACCOUNT_EVENT_INSIGHT_YAML, payload);
};

const checkAccountStatus = (accountStatusPayload) => {
  const {memberAccountIds} = accountStatusPayload;
  return get(`${url.GET_LAMBDA_CHECK_ACCOUNT_STATUS}?memberAccountIds=${memberAccountIds}`);
};

const checkStackStatus = (stackStatusPayload) => {
  const { masterAccountNumber, externalId, roleSessionName, memberAccountIds } = stackStatusPayload;

  const query = `masterAccountNumber=${encodeURIComponent(masterAccountNumber)}&externalId=${encodeURIComponent(externalId)}&roleSessionName=${encodeURIComponent(roleSessionName)}&memberAccountIds=${encodeURIComponent(memberAccountIds)}`;

  return get(`${url.GET_LAMBDA_CHECK_STACK_STATUS}?${query}`);
};

const putWafrStakeholders = (payload) => {
  const {
    accountCode,
    workloadId,
    questionId,
    stakeHolder,
    pillarId,
    questionTitle,
    assessmentName,
  } = payload;

  const queryParams = new URLSearchParams({
    accountCode,
    workloadId,
    questionId,
    pillarId,
    questionTitle,
    assessmentName,
    stakeHolder,
    requestedService: "listAttachments",
  });

  return put(`${url.WAFR_STAKEHOLDER}?${queryParams.toString()}`);
};

const getComplianceList = (complianceListPayload) => {
  const { accountNumber, date, workloadScheduleName } = complianceListPayload;

  let query = `accountNumber=${encodeURIComponent(accountNumber)}`;
  
  // Add date to query if provided
  if (date) {
    query += `&requestedScanDate=${encodeURIComponent(date)}`;
  }

  // Add workloadName to query if provided
  if (workloadScheduleName) {
    query += `&workloadScheduleName=${encodeURIComponent(workloadScheduleName)}`;
  }

  return get(`${url.GET_COMPLIANCE_LIST}?${query}`);
};

const getComplianceControls = (complianceControlsPayload) => {
  const {compliance, runId, section } = complianceControlsPayload;

  const query = `compliance=${encodeURIComponent(compliance)}&runId=${encodeURIComponent(runId)}&section=${encodeURIComponent(section)}`;

  return get(`${url.GET_COMPLIANCE_CONTROLS}?${query}`);
};

const getComplianceControlSections = (payload) => {
  const {compliance, runId } = payload;

  const query = `compliance=${encodeURIComponent(compliance)}&runId=${encodeURIComponent(runId)}`;

  return get(`${url.GET_COMPLIANCE_CONTROL_SECTION}?${query}`);
};

const getComplianceResourceList = (complianceResourceListPayload) => {
  const { resourcesUri, runId } = complianceResourceListPayload;

  const query = `resourceUri=${encodeURIComponent(resourcesUri)}&runId=${encodeURIComponent(runId)}`;

  return get(`${url.GET_COMPLIANCE_RESOURCES}?${query}`);
};

const createComplianceWorkload = (createComplianceWorkloadPayload) => {
  // Send accountNumber in the body, not as a query param
  return post(url.COMPLIANCE_WORKLOAD, createComplianceWorkloadPayload);
};

const editComplianceWorkload = (editComplianceWorkloadPayload) => {
  console.log("----== editComplianceWorkloadPayload ", url.COMPLIANCE_WORKLOAD, editComplianceWorkloadPayload);
  return put(url.COMPLIANCE_WORKLOAD, editComplianceWorkloadPayload);
};

const deleteComplianceWorkload = (deleteComplianceWorkloadPayload) => {
  console.log("----== deleteComplianceWorkloadPayload ", url.COMPLIANCE_WORKLOAD, deleteComplianceWorkloadPayload);
  const { workloadScheduleName } = deleteComplianceWorkloadPayload;
  let query = '';
  if (workloadScheduleName) query += `workloadScheduleName=${encodeURIComponent(workloadScheduleName)}`;
  const fullUrl = query ? `${url.COMPLIANCE_WORKLOAD}?${query}` : url.COMPLIANCE_WORKLOAD;
  return del(fullUrl);
};

const initiateComplianceScan = (payload) => {
  // Send accountNumber and workloadName in the body, not as query params
  return post(url.COMPLIANCE_INIATE_SCAN, payload);
};

const getComplianceTags = (payload) => {
  const { account_number, tag_key = "" } = payload;
  let query = `account_number=${encodeURIComponent(account_number)}&tag_key=${encodeURIComponent(tag_key)}`;

  return get(`${url.COMPLIANCE_TAGS}?${query}`);
};

const downloadComplianceReport = (payload) => {
  const {compliance, runId } = payload;
  
  const query = `compliance=${encodeURIComponent(compliance)}&runId=${encodeURIComponent(runId)}`;

  return get(`${url.DOWNLOAD_COMPLIANCE_REPORT}?${query}`);
};

const getCspmChecks = (payload) => {
  const { accountNumber, date, workloadScheduleName } = payload;

  let query = `accountNumber=${encodeURIComponent(accountNumber)}`;

  // Add date to query if provided
  if (date) {
    query += `&requestedScanDate=${encodeURIComponent(date)}`;
  }

  // Add workloadName to query if provided
  if (workloadScheduleName) {
    query += `&workloadScheduleName=${encodeURIComponent(workloadScheduleName)}`;
  }

  return get(`${url.GET_CSPM_CHECKS}?${query}`);
}

const getCspmResources = (payload) => {
  const {checkId, runId } = payload;

  const query = `runId=${encodeURIComponent(runId)}&checkId=${encodeURIComponent(checkId)}`;

  return get(`${url.GET_CSPM_RESOURCES}?${query}`);
}

const downloadCspmReport = (payload) => {
  const {runId } = payload;
  
  const query = `runId=${encodeURIComponent(runId)}`;

  return get(`${url.DOWNLOAD_CSPM_REPORT}?${query}`);
};

// FinOps APIs
const getFinOpsDashboard = (orgCode, accountNumber) => {
  let queryParams = [];
  
  if (orgCode) {
    queryParams.push(`orgCode=${encodeURIComponent(orgCode)}`);
  }
  
  if (accountNumber) {
    queryParams.push(`accountNumber=${encodeURIComponent(accountNumber)}`);
  }
  
  const query = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return get(`${url.GET_FINOPS_DASHBOARD}${query}`);
};

// Margin Management APIs
const getMarginRecords = (requestingOrgCode) => {
  const query = `requestingOrgCode=${encodeURIComponent(requestingOrgCode)}`;
  return get(`${url.GET_MARGIN_RECORDS}?${query}`);
};

const createMarginRecord = (payload) => {
  return post(url.POST_MARGIN_RECORD, payload);
};

const updateMarginRecord = (payload) => {
  return put(url.PUT_MARGIN_RECORD, payload);
};

const deleteMarginRecord = (marginId) => {
  const query = `marginId=${encodeURIComponent(marginId)}`;
  return del(`${url.DELETE_MARGIN_RECORD}?${query}`);
};

const getMarginSummary = (params = {}) => {
  const { start_date, end_date } = params;
  let queryString = '';
  if (start_date && end_date) {
    queryString = `?start_date=${start_date}&end_date=${end_date}`;
  }
  return get(`${url.GET_MARGIN_SUMMARY}${queryString}`);
};

// Billing Management APIs
const getBillingCustomers = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) {
    queryParams.append('page', params.page);
  }
  if (params.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  const queryString = queryParams.toString();
  return get(`${url.GET_BILLING_CUSTOMERS}${queryString ? `?${queryString}` : ''}`);
};

const getBillingRules = (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.status) {
    queryParams.append('status', params.status);
  }
  if (params.category) {
    queryParams.append('category', params.category);
  }
  if (params.customer_orgcode) {
    queryParams.append('customer_orgcode', params.customer_orgcode);
  }
  if (params.page) {
    queryParams.append('page', params.page);
  }
  if (params.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  const queryString = queryParams.toString();
  return get(`${url.GET_BILLING_RULES}${queryString ? `?${queryString}` : ''}`);
};

const getCustomerBillingRules = (customerOrgCode, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.status) {
    queryParams.append('status', params.status);
  }
  if (params.category) {
    queryParams.append('category', params.category);
  }
  if (params.page) {
    queryParams.append('page', params.page);
  }
  if (params.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  const queryString = queryParams.toString();
  return get(`${url.GET_CUSTOMER_BILLING_RULES}/${customerOrgCode}/rules${queryString ? `?${queryString}` : ''}`);
};

const getCustomerMetadata = (customerOrgCode, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.kind) {
    queryParams.append('kind', params.kind);
  }
  if (params.start_date) {
    queryParams.append('start_date', params.start_date);
  }
  if (params.end_date) {
    queryParams.append('end_date', params.end_date);
  }
  if (params.size) {
    queryParams.append('size', params.size);
  }
  const queryString = queryParams.toString();
  return get(`${url.GET_CUSTOMER_METADATA}/${customerOrgCode}/metadata${queryString ? `?${queryString}` : ''}`);
};

const createBillingRules = (customerOrgCode, rules) => {
  return post(`${url.POST_BILLING_RULES}/${customerOrgCode}/rules`, { items: rules });
};

const updateBillingRule = (customerOrgCode, ruleId, ruleData) => {
  return put(`${url.PUT_BILLING_RULE}/${customerOrgCode}/rules/${ruleId}`, ruleData);
};

const updateBillingRules = (customerOrgCode, rules) => {
  return put(`${url.PUT_BILLING_RULES}/${customerOrgCode}/rules`, { items: rules });
};

const getBillingProfile = () => {
  return get(url.GET_BILLING_PROFILE);
};

const updateBillingProfile = (profileData) => {
  return put(url.PUT_BILLING_PROFILE, profileData);
};

const getCustomerInvoices = (customerOrgCode, params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.year != null) queryParams.append('year', params.year);
  if (params.month != null) queryParams.append('month', params.month);
  if (params.status) queryParams.append('status', params.status);
  if (params.page) queryParams.append('page', params.page);
  if (params.page_size) queryParams.append('page_size', params.page_size);
  const queryString = queryParams.toString();
  return get(`${url.GET_CUSTOMER_INVOICES}/${customerOrgCode}/invoices${queryString ? `?${queryString}` : ''}`);
};

const getInvoiceRuleSnapshots = (customerOrgCode, invoiceId) => {
  return get(`${url.GET_BILLING_CUSTOMERS}/${customerOrgCode}/invoices/${invoiceId}/rules`);
};

const getInvoiceDownload = (customerOrgCode, invoiceId) => {
  return get(`${url.GET_BILLING_CUSTOMERS}/${customerOrgCode}/invoices/${invoiceId}/download`);
};

const getInvoicePreview = (customerOrgCode, invoiceId) => {
  return get(`${url.GET_BILLING_CUSTOMERS}/${customerOrgCode}/invoices/${invoiceId}/preview`);
};

const generateInvoice = (customerOrgCode, payload) => {
  return post(`${url.GET_BILLING_CUSTOMERS}/${customerOrgCode}/invoices/generate`, payload);
};

const postInvoiceAction = (customerOrgCode, invoiceId, payload) => {
  return post(`${url.GET_BILLING_CUSTOMERS}/${customerOrgCode}/invoices/${invoiceId}/action`, payload);
};

const getBillingMetrics = (metric, params = {}) => {
  const queryParams = new URLSearchParams();
  if (metric != null && metric !== "") queryParams.append("metric", metric);
  if (params.scope) queryParams.append("scope", params.scope);
  if (params.customer_orgcode) queryParams.append('customer_orgcode', params.customer_orgcode);
  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);
  if (params.year != null) queryParams.append('year', params.year);
  if (params.month != null) queryParams.append('month', params.month);
  return get(`${url.GET_BILLING_METRICS}?${queryParams.toString()}`);
};

// Compliance Suppression APIs
const getSchedules = (params) => {
  const queryParams = new URLSearchParams();
  
  if (params?.account_id) {
    queryParams.append('account_id', params.account_id);
  }
  if (params?.schedule_type) {
    queryParams.append('schedule_type', params.schedule_type);
  }
  if (params?.page) {
    queryParams.append('page', params.page);
  }
  if (params?.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  
  const query = queryParams.toString();
  return get(`${url.GET_SUPPRESSION_SCHEDULES}${query ? `?${query}` : ''}`);
};

const getFrameworks = (params) => {
  const queryParams = new URLSearchParams();
  
  if (params?.schedule_id) {
    queryParams.append('schedule_id', params.schedule_id);
  }
  if (params?.page) {
    queryParams.append('page', params.page);
  }
  if (params?.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  
  const query = queryParams.toString();
  return get(`${url.GET_SUPPRESSION_FRAMEWORKS}${query ? `?${query}` : ''}`);
};

const getControls = (complianceaddon_id, params) => {
  const queryParams = new URLSearchParams();
  
  if (params?.schedule_id) {
    queryParams.append('schedule_id', params.schedule_id);
  }
  if (params?.search) {
    queryParams.append('search', params.search);
  }
  if (params?.include_inactive !== undefined) {
    queryParams.append('include_inactive', params.include_inactive);
  }
  if (params?.page) {
    queryParams.append('page', params.page);
  }
  if (params?.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  
  const query = queryParams.toString();
  return get(`${url.GET_SUPPRESSION_CONTROLS}/${complianceaddon_id}/controls${query ? `?${query}` : ''}`);
};

const getChecks = (control_id, params) => {
  const queryParams = new URLSearchParams();
  
  if (params?.schedule_id) {
    queryParams.append('schedule_id', params.schedule_id);
  }
  if (params?.search) {
    queryParams.append('search', params.search);
  }
  if (params?.severity) {
    queryParams.append('severity', params.severity);
  }
  if (params?.service) {
    queryParams.append('service', params.service);
  }
  if (params?.include_inactive !== undefined) {
    queryParams.append('include_inactive', params.include_inactive);
  }
  if (params?.page) {
    queryParams.append('page', params.page);
  }
  if (params?.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  
  const query = queryParams.toString();
  return get(`${url.GET_SUPPRESSION_CHECKS}/${control_id}/checks${query ? `?${query}` : ''}`);
};

const getSuppressions = (schedule_id, params) => {
  const queryParams = new URLSearchParams();
  
  if (params?.page) {
    queryParams.append('page', params.page);
  }
  if (params?.page_size) {
    queryParams.append('page_size', params.page_size);
  }
  
  const query = queryParams.toString();
  return get(`${url.GET_SUPPRESSION_SUPPRESSIONS}/${schedule_id}/suppressions${query ? `?${query}` : ''}`);
};

const bulkUpsertSuppressions = (schedule_id, payload, queryParams = {}) => {
  const queryString = new URLSearchParams();
  
  if (queryParams.delete !== undefined) {
    queryString.append('delete', queryParams.delete);
  }
  if (queryParams.reset !== undefined) {
    queryString.append('reset', queryParams.reset);
  }
  if (queryParams.suppress_others !== undefined) {
    queryString.append('suppress_others', queryParams.suppress_others);
  }
  if (queryParams.framework_id) {
    queryString.append('framework_id', queryParams.framework_id);
  }
  if (queryParams.apply_to) {
    queryString.append('apply_to', queryParams.apply_to);
  }
  if (queryParams.target_schedules) {
    queryString.append('target_schedules', queryParams.target_schedules);
  }
  
  const query = queryString.toString();
  return post(`${url.POST_SUPPRESSION_BULK}/${schedule_id}/suppressions/bulk${query ? `?${query}` : ''}`, payload);
};

// Budget Management APIs
const getBudgetRecords = () => {
  return get(url.BUDGET_ENDPOINT);
};

const getBudgetResourceConfigs = () => {
  return get(url.BUDGET_RESOURCE_CONFIGS);
};

const createBudgetRecord = (payload) => {
  return post(url.BUDGET_ENDPOINT, payload);
};

const updateBudgetRecord = (payload) => {
  const { budgetId, ...updateData } = payload;
  const query = `budget_id=${encodeURIComponent(budgetId)}`;
  return put(`${url.BUDGET_ENDPOINT}?${query}`, updateData);
};

const deleteBudgetRecord = (budgetId) => {
  const query = `budget_id=${encodeURIComponent(budgetId)}`;
  return del(`${url.BUDGET_ENDPOINT}?${query}`);
};

// Organization Budget Management APIs
const getOrgBudgets = () => {
  return get(url.ORG_BUDGET_ENDPOINT);
};

const createOrgBudget = (payload) => {
  return post(url.ORG_BUDGET_ENDPOINT, payload);
};

const updateOrgBudget = (payload, budgetId) => {
  const query = `budget_id=${encodeURIComponent(budgetId)}`;
  return put(`${url.ORG_BUDGET_ENDPOINT}?${query}`, payload);
};

const deleteOrgBudget = (budgetId) => {
  const query = `budget_id=${encodeURIComponent(budgetId)}`;
  return del(`${url.ORG_BUDGET_ENDPOINT}?${query}`);
};

// Organization Budget History API
const getOrgBudgetHistory = (orgBudgetId) => {
  const query = `org_budget_id=${encodeURIComponent(orgBudgetId)}`;
  return get(`${url.GET_ORG_BUDGET_HISTORY}?${query}`);
};

// Organization Budget Alerts APIs
const getOrgBudgetAlerts = (orgBudgetId) => {
  const query = `org_budget_id=${encodeURIComponent(orgBudgetId)}`;
  return get(`${url.ORG_BUDGET_ALERTS_ENDPOINT}?${query}`);
};

const createOrgBudgetAlert = (payload) => {
  return post(url.ORG_BUDGET_ALERTS_ENDPOINT, payload);
};

const updateOrgBudgetAlert = (alertId, payload) => {
  const query = `alert_id=${encodeURIComponent(alertId)}`;
  return put(`${url.ORG_BUDGET_ALERTS_ENDPOINT}?${query}`, payload);
};

const deleteOrgBudgetAlert = (alertId) => {
  const query = `alert_id=${encodeURIComponent(alertId)}`;
  return del(`${url.ORG_BUDGET_ALERTS_ENDPOINT}?${query}`);
};

// Organization Budget Scheduled Reports APIs
const getOrgBudgetScheduledReports = (orgBudgetId) => {
  const query = `org_budget_id=${encodeURIComponent(orgBudgetId)}`;
  return get(`${url.ORG_BUDGET_SCHEDULED_REPORTS_ENDPOINT}?${query}`);
};

const createOrgBudgetScheduledReport = (payload) => {
  return post(url.ORG_BUDGET_SCHEDULED_REPORTS_ENDPOINT, payload);
};

const updateOrgBudgetScheduledReport = (reportId, payload) => {
  const query = `report_id=${encodeURIComponent(reportId)}`;
  return put(`${url.ORG_BUDGET_SCHEDULED_REPORTS_ENDPOINT}?${query}`, payload);
};

const deleteOrgBudgetScheduledReport = (reportId) => {
  const query = `report_id=${encodeURIComponent(reportId)}`;
  return del(`${url.ORG_BUDGET_SCHEDULED_REPORTS_ENDPOINT}?${query}`);
};

// Budget Group Alerts APIs
const getBudgetGroupAlerts = (rgBudgetId) => {
  const query = `rg_budget_id=${encodeURIComponent(rgBudgetId)}`;
  return get(`${url.BUDGET_GROUP_ALERTS_ENDPOINT}?${query}`);
};

const createBudgetGroupAlert = (payload) => {
  return post(url.BUDGET_GROUP_ALERTS_ENDPOINT, payload);
};

const updateBudgetGroupAlert = (alertId, payload) => {
  const query = `alert_id=${encodeURIComponent(alertId)}`;
  return put(`${url.BUDGET_GROUP_ALERTS_ENDPOINT}?${query}`, payload);
};

const deleteBudgetGroupAlert = (alertId) => {
  const query = `alert_id=${encodeURIComponent(alertId)}`;
  return del(`${url.BUDGET_GROUP_ALERTS_ENDPOINT}?${query}`);
};

// Budget Group Scheduled Reports APIs
const getBudgetGroupScheduledReports = (rgBudgetId) => {
  const query = `rg_budget_id=${encodeURIComponent(rgBudgetId)}`;
  return get(`${url.BUDGET_GROUP_SCHEDULED_REPORTS_ENDPOINT}?${query}`);
};

const createBudgetGroupScheduledReport = (payload) => {
  return post(url.BUDGET_GROUP_SCHEDULED_REPORTS_ENDPOINT, payload);
};

const updateBudgetGroupScheduledReport = (reportId, payload) => {
  const query = `report_id=${encodeURIComponent(reportId)}`;
  return put(`${url.BUDGET_GROUP_SCHEDULED_REPORTS_ENDPOINT}?${query}`, payload);
};

const deleteBudgetGroupScheduledReport = (reportId) => {
  const query = `report_id=${encodeURIComponent(reportId)}`;
  return del(`${url.BUDGET_GROUP_SCHEDULED_REPORTS_ENDPOINT}?${query}`);
};

// Budget Charts API
const getBudgetCharts = (budgetId) => {
  const query = `budget_id=${encodeURIComponent(budgetId)}`;
  return get(`${url.GET_BUDGET_CHARTS}?${query}`);
};

// Budget History API
const getBudgetHistory = (budgetId) => {
  const query = `budget_id=${encodeURIComponent(budgetId)}`;
  return get(`${url.GET_BUDGET_HISTORY}?${query}`);
};

export {
  getPricingInfo,
  getAssetInsightMetric,
  getComplianceMetric,
  getCostInsightMetric,
  getSecurityPostureMetric,
  getEventInsightMetric,
  getWafrMetric,
  postLogin,
  postVerifyTotp,
  postForgetPwd,
  resetPasswordFrgt,
  getOrgsName,
  getOrgsAndAccts,
  getLicensing,
  addNewUserPost,
  getProfileRoleInfo,
  postRegister,
  putRegister,
  getAccRules,
  getAllRules,
  getAwsAccountNumber,
  postAwsAccountNumber,
  postOrgAccount,
  editUserPatch,
  toggleUserService,
  deleteUserService,
  updateRules,
  putToggleRulezLambda,
  updateAccount,
  getActivateEmail,
  getAccountsAndTabToken,
  reActiveGet,
  validateProspectiveToken,
  addResourceGroup,
  editResourceGroup,
  deleteResourceGroup,
  getResourceGroups,
  getTabToken,
  resetPwd,
  getRuleRemediation,
  getIaacMetrics,
  getUploadFileUrl,
  postUploadFile,
  postFileCommitDetails,
  getIaacFileHistory,
  getDownloadFile,
  getIaacSubscription,
  getIaacLicense,
  postIaacSubscription,
  putIaacSubscription,
  getReleaseNotes,
  getReleaseDetails,
  postSupportEmail,
  addFulfillment,
  awsOnboard,
  postFeatureConfiguration,
  postAccountConfiguration,
  fetchFunctionCount,
  verifyBucketPolicyStatus,
  verifyAccountStatus,
  fetchKibanaDashboardsApi,
  fetchBillingRecordsApi,
  fetchTagsApi,
  fetchTagAllocationAccountsApi,
  fetchTagDetailsApi,
  uploadTagsApi,
  getOrganizationScope,
  addOrganization,
  addCustomer,
  deleteCustomer,
  getCustomerOrgAccounts,
  getWafrQuestionnaire,
  getWafrAssessmentList,
  getWafrSummary,
  updateWafrAnswer,
  postWafrAssessment,
  postWafrAssessmentPreValidate,
  postCisScan,
  getCisPosture,
  postAutomatedChecks,
  getFlaggedDetails,
  postCompleteAssessment,
  getWafrReport,
  getWafrPdfReport,
  getMilestonePdfReport,
  getMilestoneList,
  getMilestoneDetails,
  postCreateMileStone,
  postCisPosture,
  deleteWafrAssessment,
  getWafrAttachmentsUrl,
  listWafrAttachments,
  downloadWafrAttachments,
  getWafrStakeholders,
  putWafrStakeholders,
  getOrganizationalUnits,
  generateYaml,
  generateEventInsightYaml,
  checkAccountStatus,
  checkStackStatus,
  getComplianceList,
  getComplianceControls,
  getComplianceControlSections,
  getComplianceResourceList,
  createComplianceWorkload,
  editComplianceWorkload,
  deleteComplianceWorkload,
  initiateComplianceScan,
  getComplianceTags,
  downloadComplianceReport,
  getCspmChecks,
  getCspmResources,
  downloadCspmReport,
  getFinOpsDashboard,
  getMarginRecords,
  createMarginRecord,
  updateMarginRecord,
  deleteMarginRecord,
  getMarginSummary,
  getSchedules,
  getFrameworks,
  getControls,
  getChecks,
  getSuppressions,
  bulkUpsertSuppressions,
  getBudgetRecords,
  getBudgetResourceConfigs,
  createBudgetRecord,
  updateBudgetRecord,
  deleteBudgetRecord,
  getOrgBudgets,
  createOrgBudget,
  updateOrgBudget,
  deleteOrgBudget,
  getOrgBudgetHistory,
  getOrgBudgetAlerts,
  createOrgBudgetAlert,
  updateOrgBudgetAlert,
  deleteOrgBudgetAlert,
  getOrgBudgetScheduledReports,
  createOrgBudgetScheduledReport,
  updateOrgBudgetScheduledReport,
  deleteOrgBudgetScheduledReport,
  getBudgetGroupAlerts,
  createBudgetGroupAlert,
  updateBudgetGroupAlert,
  deleteBudgetGroupAlert,
  getBudgetGroupScheduledReports,
  createBudgetGroupScheduledReport,
  updateBudgetGroupScheduledReport,
  deleteBudgetGroupScheduledReport,
  getBudgetCharts,
  getBudgetHistory,
  getBillingCustomers,
  getBillingRules,
  getCustomerBillingRules,
  getCustomerMetadata,
  createBillingRules,
  updateBillingRule,
  updateBillingRules,
  getBillingProfile,
  updateBillingProfile,
  getCustomerInvoices,
  getInvoiceRuleSnapshots,
  getInvoiceDownload,
  getInvoicePreview,
  generateInvoice,
  postInvoiceAction,
  getBillingMetrics,
};
